import { Product } from '@Types/product.types';
import { addNamespace } from '@Utils/actions';
import { createAction } from '@reduxjs/toolkit';

export const getProducts = createAction(addNamespace('products/getProducts'));
export const getProductsResolved = createAction<Product[]>(
	addNamespace('products/getProducts/resolved'),
);
export const getProductsRejected = createAction(
	addNamespace('products/getProducts/rejected'),
);
